import FamilyApplications from './FamilyApplications';

export default FamilyApplications;
